import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";
import ReadAxios from "./../axiosComponent/read";
import {consigneeConsignorCheck} from '../../utils/constant'

export class DeliveriesActionCollection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPdf: false,
    };
  }
  handlePDFOpen = () => {
    //this.props.agGridReact.props.getEditDetails(this.props.data)
    let lrNO = this.props.data.lr_no
    if (this.props?.data?.lr_no) {
      this.setState({
        isPdf: true,
      });
      ReadAxios({
        baseURL: `${process.env.REACT_APP_BASE_COMMON}`,
        url: "lr/generatePdf",
        readItems: {
          lrNo: lrNO,
          roleName: localStorage.getItem('role')
        },
      }).then((response) => {
        let url = response.data;
        this.setState({
          isPdf: false,
        });
        window.open(url, "_blank");
      });
    }

  };
  handleViewDeliveries = () => {
    this.props.agGridReact.props.openDeliveryModal(this.props.data, 'view')
  };
  handleEditDeliveries = () => {
    this.props.agGridReact.props.openDeliveryModal(this.props.data, 'edit')
  };


  render() {
    return (
      <>
        <Button
          onClick={this.handlePDFOpen}
          //disabled={this.props?.data?.status == 'In Progress' || this.props?.data?.status == 'Completed' ? true : false}
          basic
          size="mini"
          type="button"
          icon
        >
          {" "}
          <Icon name="file pdf outline" color="red" />
        </Button>
        {!consigneeConsignorCheck(localStorage.getItem('role')) && 
        <>
        <Button
          onClick={this.handleViewDeliveries}
          //disabled={this.props?.data?.status == 'In Progress' || this.props?.data?.status == 'Completed' ? true : false}
          basic
          size="mini"
          type="button"
          icon
        >
          {" "}
          <Icon name="eye" color="blue" />
        </Button>
       
        <Button
          onClick={this.handleEditDeliveries}
          //disabled={this.props?.data?.status == 'In Progress' || this.props?.data?.status == 'Completed' ? true : false}
          basic
          size="mini"
          type="button"
          icon
        >
          {" "}
          <Icon name="pencil" color="blue" />
        </Button>
         </> }
        {/*  <Button
          //onClick={this.handleViewDeliveries}
          //disabled={this.props?.data?.status == 'In Progress' || this.props?.data?.status == 'Completed' ? true : false}
          basic
          size="mini"
          type="button"
          icon
        >
          {" "}
          <Icon name="eye" color="blue" />
        </Button>
        <Button
          //onClick={this.handleViewDeliveries}
          //disabled={this.props?.data?.status == 'In Progress' || this.props?.data?.status == 'Completed' ? true : false}
          basic
          size="mini"
          type="button"
          icon
        >
          {" "}
          <Icon name="trash" color="red" />
        </Button> */}
      </>
    );
  }
}


export default DeliveriesActionCollection;
